import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import type { ChatBatchResult } from '../ChatBatchResult'

@InputType()
export class BatchUpdateChatTagsArgs extends ActionArgs {
  @Field(() => [ID])
  chatIds: string[]

  @Field(() => [String])
  tags: string[]
}

export interface IBatchUpdateChatTags extends IAction<ChatBatchResult, BatchUpdateChatTagsArgs> {}
